import React from 'react';
import * as Sentry from "@sentry/react";

const SentryTest: React.FC = () => {
  const throwError = () => {
    throw new Error("This is a test error for Sentry!");
  };

  const throwAsyncError = async () => {
    try {
      await new Promise((_, reject) => {
        setTimeout(() => reject(new Error("Async error for Sentry!")), 100);
      });
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const sendCustomEvent = () => {
    Sentry.captureMessage("User clicked test button", "info");
  };

  const testUserFeedback = () => {
    Sentry.showReportDialog({
      eventId: "test-event-id",
      title: "Feedback Test",
      subtitle: "This is a test feedback dialog",
      subtitle2: "Try filling out the form",
      labelName: "Name",
      labelEmail: "Email", 
      labelComments: "Comment",
      labelClose: "Close",
      labelSubmit: "Submit",
      errorGeneric: "Submission error",
      errorFormEntry: "Form error",
      successMessage: "Thank you for your feedback!"
    });
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-semibold mb-4">Тестирование Sentry</h2>
      <div className="space-y-3">
        <button
          onClick={throwError}
          className="w-full bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition-colors"
        >
          Throw synchronous error
        </button>
        
        <button
          onClick={throwAsyncError}
          className="w-full bg-orange-600 text-white px-4 py-2 rounded hover:bg-orange-700 transition-colors"
        >
          Throw async error
        </button>
        
        <button
          onClick={sendCustomEvent}
          className="w-full bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
        >
          Send custom event
        </button>
        
        <button
          onClick={testUserFeedback}
          className="w-full bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition-colors"
        >
          Test feedback dialog
        </button>
      </div>
      
      <div className="mt-4 p-3 bg-gray-100 rounded text-sm">
        <p className="font-medium mb-2">What happens:</p>
        <ul className="list-disc list-inside space-y-1 text-gray-700">
          <li>Errors are automatically sent to Sentry</li>
          <li>Feedback dialog is shown</li>
          <li>User can describe the problem</li>
          <li>Feedback is linked to technical error</li>
        </ul>
      </div>
    </div>
  );
};

export default SentryTest; 